import axios from "axios";
import { API_ORIGIN } from "../../config/env";
import { getAuthHeaders } from "../../utils/auth";

const statsUrl = `${API_ORIGIN}/api/v1/admin/dashboard/stats`;

export function getDashboardStats() {
  return axios.get(statsUrl, {
    headers: getAuthHeaders(),
  });
}
